import { db } from "../firebase";
import Firebase from "firebase";
import { element } from "prop-types";

// Example save to doc with auto doc id: doc()
export function addExample(doc_id_1, data, callback) {

  let docRef = db.collection("example").doc(doc_id_1).collection("example").doc()

  docRef.set({
      example: data,
    })
    .then( () => {
      callback()
    })
    .catch( (error) => {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
    });
}

export function addClient(mail, user_id, image, name, callback) {
  debugger
  console.log('---->>>>Save: addClient');
  let mailRef = db.collection('mail');
  let clientsRef = db.collection('clients');
  let pendingRef = db.collection('pending_clients');

  clientsRef
    .where('email', '==', mail)
    .get()
    .then(querySnapshot => {
      if (querySnapshot.size > 0) {
        debugger
        let _doc = querySnapshot.docs[0];
        clientsRef
          .doc(_doc.id)
          .update({invitations: Firebase.firestore.FieldValue.arrayUnion({coach_id: user_id})})
          .then(() => {
            mailRef.doc().set({
              to: mail,
              message: {
                subject: "You're invited by " + name,
                html: `
                ${image && image.length > 0 ? `<img src="${image}" style="width:100px; height: 100px; border-radius: 50px;"/>` : "" }
                <p>Go to settings and accept ${name}'s invitation.</p>
                <a href="https://aurumstrength.com/">Accept invitation</a>
                `,
              },
            }).then(() => {
              callback(true)
            }).catch(err => {
              callback(false)
            })
          }).catch(err => {
            callback(false)
          })
      } else {
        debugger
        pendingRef.doc().set({coach_id: user_id, client_email: mail, created: new Date()}).then(() => {
          debugger
          mailRef.doc().set({
            to: mail,
            message: {
              subject: "You're invited by " + name,
              html: `
              ${image && image.length > 0 ? `<img src="${image}" style="width:100px; height: 100px; border-radius: 50px;" />` : "" }
              <p>Create an account on www.aurumstrength.com or on our mobile app, and accept ${name}'s (${mail}) invitation in order to start working with your favorite coach!.</p>
              <a href="https://aurumstrength.com/">Create account</a>
              `,
            },
          }).then(() => {
            debugger
            callback(true)
          }).catch(err => {
            debugger
            callback(false)
          })
        }).catch(err => {
          debugger
          callback(false)
        })
      }
    });
}

// Example save to doc with auto doc id: doc()
export function addTag(tag, callback) {

  let docRef = db.collection("tags")

  docRef.add({
    name: tag,
    })
    .then( (docRef) => {
      callback(docRef.id)
    })
    .catch( (error) => {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
    });
}

export function addExerciseAurum(content, callback) {

  let docRef = db.collection("exercises")

  docRef.add(content)
    .then( (docRef) => {
      callback(docRef.id)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addProgramAurum(content, callback) {

  let docRef = db.collection("programs")

  docRef.add(content)
    .then( (docRef) => {
      callback(docRef)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addProgramWorkoutAurum(programID, content, callback) {

  let docRef = db.collection("programs").doc(programID).collection("workouts")

  docRef.add(content)
    .then( (docRef) => {
      callback(docRef)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addExerciseCoach(uid, content, callback) {

  let docRef = db.collection("coaches").doc(uid).collection("exercises")

  docRef.add(content)
    .then( (docRef) => {
      callback(docRef.id)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addProgramCoach(uid, content, callback) {
  debugger
  console.log("add",{uid:uid,content:content})
  let docRef = db.collection("coaches").doc(uid).collection("programs")

  docRef.add(content)
    .then( (docRef) => {
      callback(docRef.id)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addProgramWorkoutCoach(uid, content, programID, callback) {
  console.log(uid, content, programID);

  let docRef = db.collection("coaches").doc(uid).collection("programs").doc(programID).collection('workouts')

  docRef.add(content)
    .then( (docRef) => {
      callback(docRef.id)
    })
    .catch( (error) => {
      callback(false)
    });
}


export function addWorkoutAurum(content, callback) {

  let docRef = db.collection("workouts")

  docRef.add(content)
    .then( (docRef) => {
      callback(docRef.id)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addWorkoutCoach(uid, content, callback) {

  let docRef = db.collection("coaches").doc(uid).collection("workouts")

  docRef.add(content)
    .then( (docRef) => {
      callback(docRef.id)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addWorkoutClient(client_id, supersets, time, callback) {
  let docRef = db.collection("clients").doc(client_id).collection("workouts").doc(time);

  docRef.set(supersets)
  .then( (docRef) => {
    callback(docRef.id)
  })
  .catch( (error) => {
    callback(false)
  });
}

export function addMealplanAurum(content, callback) {
  console.log(content);
  //return false;
  let docRef = db.collection("mealplans")

  docRef.add(content)
    .then( (docRef) => {
      callback(docRef.id)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addMealplanCoach(uid, content, callback) {

  let docRef = db.collection("coaches").doc(uid).collection("mealplans")

  docRef.add(content)
    .then( (docRef) => {
      callback(docRef.id)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addMealplanClient(client_id, content, time, callback) {

  let docRef = db.collection("clients").doc(client_id).collection("mealplans");

  let mealitems = content.plan;
  let counter = 0;
  let totalCaloriesAllowed = 0;
  mealitems.forEach(element => {
    let fooditems = element.food;
    let totalMealCalories = 0;
    fooditems.forEach(element => {
      totalMealCalories += parseInt(element.calories);
    });
    content.plan[counter]['totalCaloriesAllowed'] = totalMealCalories;
    totalCaloriesAllowed += parseInt(totalMealCalories);
    counter++;
  });

  docRef.doc(time).set({
    plan: content.plan,
    totalCaloriesAllowed: totalCaloriesAllowed
  })
  .then( (docRef) => {
    callback(docRef.id)
  })
  .catch( (error) => {
    callback(false)
  });
}
//add macros
export function addMacros(client_id, date, content, callback) {
  debugger
  console.log('---->>>>Save: addMacros');
  console.log(content);
  let macros = db.collection('clients').doc(client_id).collection('macros').doc(date);

  debugger
  macros.set(content).then(doc => {
    debugger
    console.log('Response', doc)
    callback(true);
  });
   
}

// logsAdd

export const logsAdd = (client_id, date, content, callback) => {
  console.log('---->>>>Save: logsAdd'); 
  let docef = db.collection('clients').doc(client_id).collection('workouts').doc(date) .collection('logs').doc();
  docef.set(content, { merge: true }).then(doc => {
    callback(true);
  });
};

//add logs history
export const addLogsHistory = (client_id, exerciseId, content, callback) => {
  console.log('---->>>>Save: addLogsHistory');
  console.log("client_id",client_id,"exerciseId",exerciseId,"content",content)
  let docRef = db.collection('clients').doc(client_id).collection('setshistory').doc(exerciseId);

  docRef.set(content).then(doc => {
    callback(true);
  });
};

export const getMacrosData = (client_id, date, callback) => {
  // debugger
  console.log('---->>>>Get: getMacrosData');
  let macrosRef = db.collection('clients').doc(client_id).collection('macros').doc(date);

  macrosRef.get().then(doc => {
    console.log('DOC ', doc);
    if (doc.exists) {
      // debugger
      callback({...doc.data(), id: doc.id});
    } else {
      // debugger
      callback(false);
    }
  });
};

export function addFormItemAurum(doc_id, sub_doc_id, content, callback) {
  let docRef

  if(sub_doc_id){
    docRef = db.collection("forms").doc(doc_id).collection("sub_forms").doc(sub_doc_id)
  }else{
    docRef = db.collection("forms").doc(doc_id)
  }

  docRef.set({form: Firebase.firestore.FieldValue.arrayUnion(content)}, {merge:true})
    .then( () => {
      callback(true)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addFormItemCoach(uid, doc_id, sub_doc_id, content, callback) {
  let docRef

  if(sub_doc_id){
    docRef = db.collection("coaches").doc(uid).collection("forms").doc(doc_id).collection("sub_forms").doc(sub_doc_id)
  }else{
    docRef = db.collection("coaches").doc(uid).collection("forms").doc(doc_id)
  }

  docRef.set({form: Firebase.firestore.FieldValue.arrayUnion(content)}, {merge:true})
    .then( () => {
      callback(true)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function copyFormItemToCoach(uid, doc_id, sub_doc_id, content, callback) {
  let docRef

  if(sub_doc_id){
    docRef = db.collection("coaches").doc(uid).collection("forms").doc(doc_id).collection("sub_forms").doc(sub_doc_id)
  }else{
    docRef = db.collection("coaches").doc(uid).collection("forms").doc(doc_id)
  }

  docRef.set({form: Firebase.firestore.FieldValue.arrayUnion(content)}, {merge:true})
    .then( () => {
      callback(true)
    })
    .catch( (error) => {
      callback(false)
    });
}


export async function createFormTest(){
  const querySnapshot_forms = await db.collection("forms").get()
  await Promise.all(querySnapshot_forms.docs.map(async doc => {
      return await db.collection("coaches").doc("ahRjqkTA2nPz2dOg7C2jguHcxtw2").collection("forms").doc(doc.id).set(doc.data())
  })).then(async() => {
      const querySnapshot = await db.collection("forms").doc("intake_form").collection("sub_forms").get()
      await Promise.all(querySnapshot.docs.map(async doc => {
          return await db.collection("coaches").doc("ahRjqkTA2nPz2dOg7C2jguHcxtw2").collection("forms").doc("intake_form").collection("sub_forms").doc(doc.id).set(doc.data())
      })).then((results) => {
          return results
      }).catch((err) => {
          console.error(err)
          return err
      })
  }).catch((err) => {
      console.error(err)
      return
  })
}

export function saveMessage(client_id, content, callback) {

  let docRef = db.collection("clients").doc(client_id).collection("Chat")

  docRef.add(content)
    .then( (docRef) => {
      callback(docRef.id)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addDailyProgressClient(client_id, content, time, currentTime, callback) {
  let docRefGet = db.collection("clients").doc(client_id);

  let userData = [];
  docRefGet.get().then((doc) => {
      if(doc.exists){
        let _push = {}; _push = doc.data(); _push.id = doc.id;
        userData = _push;
        let measurements = userData;
        let docRef = db.collection("clients").doc(client_id).collection("measurements");
        let docRefClient = db.collection("clients").doc(client_id);
        let bmi = ((content.bodyWeight / userData.measurements.length / userData.measurements.length) * 10000).toFixed(2);
        let length = userData.measurements.length;
       
        measurements.measurements =  {
          weight: content.bodyWeight,
          bodyMass: content.bodyMass,
          chest: content.chest,
          belly: content.belly,
          thigh: content.thigh,
          triceps: content.triceps,
          subscapula: content.subscapula,
          hip: content.hip,
          midaxillary: content.midaxillary,
          time: Math.round(new Date(time).getTime() / 1000),
          bodyfat: content.bodyfat,
          bmi: bmi,
          length: length
        }
        // todo add the rest of client info and change measurements. then add
        if(time === currentTime) {
          docRefClient.set({
            measurements: measurements.measurements
          }, { merge: true })
      }
        // make sure to save time as a number, if string all graphs break
        docRef.doc(time).set({
          weight: content.bodyWeight,
          bodyMass: content.bodyMass,
          chest: content.chest,
          belly: content.belly,
          thigh: content.thigh,
          triceps: content.triceps,
          subscapula: content.subscapula,
          hip: content.hip,
          midaxillary: content.midaxillary,
          time: Math.round(new Date(time).getTime() / 1000),
          bodyfat: content.bodyfat,
          bmi: bmi,
          length: length
        })
        .then( (docRef) => {
          callback(docRef.id)
        })
        .catch( (error) => {
          callback(false)
        });
      }
  }); 
}

export function addTodoClient(client, user_id, time, callback) {
  let docRef = db.collection("coaches").doc(user_id).collection("calendar").doc(time).collection("clients");
  db.collection("coaches").doc(user_id).collection("calendar").doc(time).set({
    "id": time,
  })
  docRef.add(client)
    .then( (docRef) => {
      callback(docRef.id)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addTodoTask(task, user_id, time, callback) {
  let docRef = db.collection("coaches").doc(user_id).collection("calendar").doc(time).collection("tasks");
  db.collection("coaches").doc(user_id).collection("calendar").doc(time).set({
    "id": time,
  })
  docRef.add(task)
    .then( (docRef) => {
      callback(docRef.id)
    })
    .catch( (error) => {
      callback(false)
    });
}

export function addFrontImageClient(client_id, time, frontImage) {
  let docRef = db.collection("clients").doc(client_id).collection("measurements").doc(time);
  docRef.set({
    imageFront: frontImage
  }, { merge: true })
  let docRef2 = db.collection("clients").doc(client_id);
  docRef2.set({
    measurements: {
      imageFront: frontImage
    }
  }, { merge: true })
}

export function addSideImageClient(client_id, time, sideImage) {
  let docRef = db.collection("clients").doc(client_id).collection("measurements").doc(time);
  docRef.set({
    imageSide: sideImage
  }, { merge: true })
  let docRef2 = db.collection("clients").doc(client_id);
  docRef2.set({
    measurements: {
      imageSide: sideImage
    }
  }, { merge: true })
}

export function addBackImageClient(client_id, time, backImage) {
  let docRef = db.collection("clients").doc(client_id).collection("measurements").doc(time);
  docRef.set({
    imageBack: backImage
  }, { merge: true })
  let docRef2 = db.collection("clients").doc(client_id);
  docRef2.set({
    measurements: {
      imageBack: backImage
    }
  }, { merge: true })
}